import type { Fides } from 'utils/fides';

export const DEFAULT_PRIVACY_PREFERENCES: Fides['consent'] = {
  data_sales_and_sharing: true,
};
